import { render, staticRenderFns } from "./WhatsYourSignature.vue?vue&type=template&id=878b93ac&"
import script from "./WhatsYourSignature.vue?vue&type=script&lang=ts&"
export * from "./WhatsYourSignature.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsYourSignature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports